'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var nthHookTheme = require('@narvar/nth-hook-theme');
var OptionProvider = require('../../components/OptionProvider.js');
var styles_module = require('./styles.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function Button(_ref) {
  let {
    fixedWidth = false
  } = _ref;
  const {
    bodytextDefaultNone: bodyText,
    selecteditemNoneNone: selecteditem,
    panelcontainerNoneNone: panelContainer,
    buttonsSecondaryDefault: buttonsSecondary
  } = nthHookTheme.useTheme();
  const {
    option: {
      label,
      isGrayedOut
    },
    isSelected,
    isDisabled,
    isFocused,
    isHovered
  } = OptionProvider.useOption();
  const containerClassNames = clsx.clsx(styles_module["default"].container, isDisabled && styles_module["default"].containerDisabled, isGrayedOut && styles_module["default"].containerGrayedOut);
  const buttonClassNames = clsx.clsx(styles_module["default"].button, isDisabled && styles_module["default"].buttonDisabled, isSelected && styles_module["default"].buttonSelected, isFocused && styles_module["default"].buttonFocused, fixedWidth && styles_module["default"].buttonFixedWidth, isGrayedOut && styles_module["default"].buttonGrayedOut);
  const buttonTheme = {
    color: isSelected ? 'white' : (bodyText === null || bodyText === void 0 ? void 0 : bodyText.color) ?? 'black',
    background: isSelected ? (selecteditem === null || selecteditem === void 0 ? void 0 : selecteditem.borderTopColor) ?? 'black' : 'white',
    borderColor: !isDisabled && (isSelected || isFocused || isHovered) ? (selecteditem === null || selecteditem === void 0 ? void 0 : selecteditem.borderTopColor) ?? 'black' : (panelContainer === null || panelContainer === void 0 ? void 0 : panelContainer.borderTopColor) ?? 'lightgray',
    fontFamily: selecteditem === null || selecteditem === void 0 ? void 0 : selecteditem.fontFamily,
    fontWeight: selecteditem === null || selecteditem === void 0 ? void 0 : selecteditem.fontWeight
  };
  const buttonWrapperTheme = {
    background: buttonsSecondary ? buttonsSecondary.backgroundColor : 'white'
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: containerClassNames
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles_module["default"].buttonWrapper,
    style: buttonWrapperTheme
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: buttonClassNames,
    style: buttonTheme,
    tabIndex: -1
  }, label)));
}
var Button$1 = nthHookTheme.withThemeProvider(Button, {
  themeTokens: ['bodytextDefaultNone', 'buttonsPrimaryDefault', 'selecteditemNoneNone', 'panelcontainerNoneNone', 'buttonsSecondaryDefault']
});

exports["default"] = Button$1;
